import script from "./BaseLayout2575and7525.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLayout2575and7525.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__